import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class LicenseTypesService {
  constructor(private http: HttpClient) {}

  public fetchLicenseTypes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType/list`
    return this.http.post(url, params)
  }
  public fetchLicenseType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType/${id}`
    return this.http.get(url, {})
  }

  public deleteLicenseType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType/${id}`
    return this.http.delete(url)
  }

  public createLicenseType(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType`
    return this.http.post(url, params)
  }

  public updateLicenseType(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType/${id}`
    return this.http.put(url, params)
  }

  public fetchDefaultPrefix(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/licenseType/defaultPrefix`
    return this.http.get(url, {})
  }
}
